import { render, staticRenderFns } from "./EvaluationSetting.vue?vue&type=template&id=dba00834&scoped=true"
import script from "./EvaluationSetting.vue?vue&type=script&lang=js"
export * from "./EvaluationSetting.vue?vue&type=script&lang=js"
import style0 from "./EvaluationSetting.vue?vue&type=style&index=0&id=dba00834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba00834",
  null
  
)

export default component.exports